import CloseIcon from '@mui/icons-material/CloseOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';
import { Box, Button, Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useState } from 'react';
import { IAvailableListItem } from "../../routes/doa-forecast-doa-admin-stats/DoaForecastStatsData";
import { AvailabelityDisclaimer } from './AvailabilityDisclaimer';
import { availabilityDisclaimerContentStyle, closeButtonStyle, headerCellStyle, legendStyle, phoneStyle, warningIconStyle } from './styled';

export interface IAvailbaleTableProps {
  isDoaAdmin: boolean,
  list?: IAvailableListItem[],
  redBorderClassName: string,
  loading: boolean,
  onOpenClosePlateModal: (regId: number, board: string) => void,
  onClose: () => void,
}

export const AvailableTable: React.FC<IAvailbaleTableProps> = ({
  isDoaAdmin,
  list,
  redBorderClassName,
  loading,
  onClose,
  onOpenClosePlateModal
}) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const onShowDisclaimer = () => setShowDisclaimer(prev => !prev);
  return (
    <TableRow className={`${redBorderClassName} subTableHeadRow`}>
      <TableCell className='noPadding' colSpan={isDoaAdmin ? 9 : 7}>
        {!loading &&
          <Table className='availabilityTable'>
            <TableHead>
              <TableRow>
                <TableCell sx={{ position: 'relative' }} colSpan={4}>
                  <Box sx={{ ...headerCellStyle, justifyContent: 'space-between' }}>
                    Rated Employees Who Have Made Themselves Available
                    <Box sx={closeButtonStyle} onClick={onClose}><CloseIcon /></Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ position: 'relative' }} colSpan={4}>
                  {showDisclaimer &&
                    <Box sx={availabilityDisclaimerContentStyle}>
                      <AvailabelityDisclaimer handleClick={onShowDisclaimer} />
                    </Box>
                  }
                  <Box sx={headerCellStyle}>
                    <Box onClick={onShowDisclaimer} sx={legendStyle}>Legend <FormatListBulletedIcon /></Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!list?.length && <TableRow>
                <TableCell colSpan={4} className='noData'>
                  No data
                </TableCell>
              </TableRow>}
              {list?.map((item, i) => (
                <TableRow key={i}>
                  <TableCell sx={{ background: item.plateColour, color: 'black' }}>
                    <Typography>{item.employeeFullName}</Typography>
                    {item.lastWorkedDate && <Typography>Last Worked: {item.lastWorkedDate}</Typography>}
                    {item.suspensionLevelDescription && <Typography>
                      <WarningTwoToneIcon sx={warningIconStyle} />
                      {item.suspensionLevelDescription}
                    </Typography>}
                  </TableCell>
                  <TableCell
                    sx={{ background: item.jobColour }}
                    className={item.isAssigned ? 'hasBoldBorder' : ''}
                  >
                    {item.jobOrReason}
                  </TableCell>
                  <TableCell>
                    <Typography>{item.regId}</Typography>
                    {item.boardPlate && <Button
                      onClick={() => onOpenClosePlateModal(item.regId, item.board)}
                      variant="outlined"
                    >
                      {item.boardPlate}
                    </Button>}
                  </TableCell>
                  <TableCell>
                    <Typography sx={phoneStyle}>P: <Link href={`tel:${item.primaryPhoneNumber}`}>{item.primaryPhoneNumber}</Link></Typography>
                    <Typography sx={phoneStyle}>A: <Link href={`tel:${item.altPhoneNumber}`}>{item.altPhoneNumber}</Link></Typography>
                    <Typography sx={phoneStyle}>C: <Link href={`tel:${item.cellPhoneNumber}`}>{item.cellPhoneNumber}</Link></Typography>
                  </TableCell>
                </TableRow>))
              }
            </TableBody>
          </Table>
        }
      </TableCell>
    </TableRow>)
}   